import { createContext, useState, ReactNode, useContext } from 'react';
import { useEnvironment } from "@keycloak/keycloak-ui-shared";
import {usePromise} from "../utils/usePromise";
import {CallOptions} from "../api/methods";
import {Environment} from "../environment";
import { MenuItem } from '../root/PageNav';
import { joinPath } from '../utils/joinPath';

type Content = MenuItem[];

export const ContentContext = createContext<Content | null>(null);

export function useContentContext() {
    const context = useContext(ContentContext);

    if (!context) {
        throw new Error('ContentContext must be used within ContentProvider');
    }

    return context;
}

interface ContentProviderProps {
    children: ReactNode;
}

export const ContentProvider = ({ children }: ContentProviderProps) => {
    const content = useContent();

    return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
};

function useContent(): Content {
    const context = useEnvironment<Environment>();
    const [content, setContent] = useState<Content>([]);

    usePromise(
        (signal) => fetchContentJson({signal, context}),
        (content) => setContent(content)
    );

    return content;
}

export async function fetchContentJson(
  opts: CallOptions,
): Promise<MenuItem[]> {
  const response = await fetch(
    joinPath(opts.context.environment.resourceUrl, "/content.json"),
    opts,
  );
  return await response.json();
}

